import React, { useEffect, useState } from "react";
import api from "../../../services/baseUrl";

const AccountRegistration = ({ formData, setFormData, nextStep }) => {
  const [categoryList, setCategoryList] = useState([]);
  const [packageList, setPackageList] = useState([]);

  useEffect(() => {
    const fetchcategoryList = async () => {
      try {
        const response = await api.get("/categoryList");
        const data = response.data;
        setCategoryList(data);
      } catch (err) {}
    };

    const fetchPackageList = async () => {
      try {
        const response = await api.get("/packageList");
        const data = response.data;
        setPackageList(data);
      } catch (err) {}
    };

    fetchPackageList();
    fetchcategoryList();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newValue =
      e.target.type === "select-one"
        ? value
          ? parseInt(value, 10)
          : ""
        : value;

    setFormData({ ...formData, [name]: newValue });
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const [errors, setErrors] = useState({
    name: "",
    packageID: "",
    categoryId: "",
  });

  const validateForm = () => {
    let formErrors = {};
    if (!formData.name) formErrors.name = "Full Name is required";
    if (!formData.packageID) formErrors.packageID = "Package is required";
    if (!formData.categoryId)
      formErrors.categoryId = "Business type is required";
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0; // Return true if no errors
  };

  const handleNextStep = () => {
    if (validateForm()) {
      nextStep();
    }
  };

  const agencyList = [
    { id: 1, name: "Ministry of Finance" },
    { id: 2, name: "Ministry of Health" },
    { id: 3, name: "Ministry of Education" },
    { id: 4, name: "Road Transport Department" },
    { id: 5, name: "Immigration Department" },
  ];

  return (
    <>
      <h1>Create An Account</h1>
      <h2>Step&nbsp;1:&nbsp;Account&nbsp;Registration</h2>
      <form className="register1-form">
        <div>
          <div className="dialog-input-field">
            <label htmlFor="name">Full Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
            />
            {errors.name && <span className="form-error">{errors.name}</span>}
          </div>

          <div className="dialog-input-field">
            <label htmlFor="packageID">Package</label>
            <select
              name="packageID"
              value={formData.packageID}
              onChange={handleChange}
            >
              {packageList.map((packages, index) => (
                <option key={index} value={packages.packageCode}>
                  {packages.packageName}
                </option>
              ))}
            </select>
            {errors.packageID && (
              <span className="form-error">{errors.packageID}</span>
            )}
          </div>

          <div className="dialog-input-field">
            <label htmlFor="categoryId">Business Type</label>
            <select
              name="categoryId"
              value={formData.categoryId}
              onChange={handleChange}
            >
              {categoryList.map((category, index) => (
                <option key={index} value={category.id}>
                  {category.name}
                </option>
              ))}
            </select>
            {errors.categoryId && (
              <span className="form-error">{errors.categoryId}</span>
            )}
          </div>

          {formData.categoryId === 5 && (
            <div className="dialog-input-field">
              <label htmlFor="govAgencyId">Government Agency</label>
              <select
                name="govAgencyId"
                value={formData.govAgencyId}
                onChange={handleChange}
              >
                <option value="">Select an agency</option>
                {agencyList.map((agency, index) => (
                  <option key={index} value={agency.id}>
                    {agency.name}
                  </option>
                ))}
              </select>
              {errors.agencyId && (
                <span className="form-error">{errors.agencyId}</span>
              )}
            </div>
          )}
          <button
            className="register1-button"
            type="button"
            onClick={handleNextStep}
          >
            Next
          </button>
        </div>
      </form>
    </>
  );
};

export default AccountRegistration;
